<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Edit User KYC Detail
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="3">
              <v-autocomplete
                ref="documents"
                outlined
                v-model="form.doc_name_id"
                :items="documentItems"
                readonly
                label="Document Type *"
                prepend-inner-icon="mdi-account-tie-outline"
                :error-messages="errors.doc_name_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="3">
              <v-text-field
                v-model="form.doc_no"
                outlined
                label="Document No *"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.doc_no"
              ></v-text-field>
            </v-col>
            <v-col sm="3">
              <v-file-input
                v-model="form.doc_path"
                label="Upload Document"
                accept="image/*"
                show-size
                dense
                :ref="`fileInput`"
                @change="onFileChange"
              ></v-file-input>

              <div v-if="previewImage" class="mt-5">
                <label>Image Preview</label>
                <br />
                <img
                  :src="previewImage"
                  style="height: 30%; width: 30%; object-fit: contain"
                />
              </div>
            </v-col>
            <v-col sm="3">
              <v-autocomplete
                ref="status"
                outlined
                v-model="form.status"
                :items="statusItems"
                label="Status *"
                prepend-inner-icon="mdi-account-tie-outline"
                clearable
                :error-messages="errors.status"
              ></v-autocomplete>
            </v-col>
            <v-col sm="3">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_active"
                inset
                :label="`Is Active: ${form.is_active ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Update User KYC Detail
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";

export default {
  name: "UsersKYCDetailIdPage",
  data() {
    return {
      form: {
        is_active: false,
      },
      isLoading: false,
      previewImage: null, // Add this to data
      originalDocPath: null, // Store original path for API calls
      documentItems: [],
      statusItems: [
        { id: 1, text: "APPROVED", value: 1 },
        { id: 2, text: "PENDING", value: 0 },
      ],
    };
  },
  computed: {
    errors() {
      return this.$store.getters["errors/getErrors"] || {};
    },
  },
  mounted() {
    this.$store.dispatch("errors/setErrors", {});
    this.getData();
    this.getMasters();
  },
  methods: {
    async getMasters() {
      await axios
        .get(`masters?context=kyc_detail`)
        .then((masters) => {
          masters = masters.data;
          //documents
          masters.documents.forEach((document) => {
            this.documentItems.push({
              id: document.id,
              text: document.description,
              value: document.id,
            });
          });
          //user
          masters.users.forEach((user) => {
            this.userItems.push({
              id: user.id,
              text: user.user_name,
              value: user.id,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          // redirect to Home Page
          // window.location.href = "/auth/login";
        });
    },
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.userDetailId;
      axios
        .get(`/user_kyc_details/${encryptedId}`)
        .then((response) => {
          this.form = response.data.data;
          this.old_json = response.data.data;
          // Set preview image URLs
          if (this.form.doc_path) {
            this.originalDocPath = this.form.doc_path; // Store original path
            this.previewImage = this.mediaUrl + this.form.doc_path; // Set preview URL
            this.form.doc_path = null; // Reset form field for file input
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
      this.isLoading = false;
    },
    async save() {
      let formData = new FormData();

      formData.append("doc_name_id", this.form.doc_name_id);
      formData.append("doc_no", this.form.doc_no);
      formData.append("status", this.form.status);
      formData.append("is_active", this.form.is_active ? 1 : 0);

      // Append only if new file is uploaded
      if (this.form.doc_path instanceof File) {
        formData.append("doc_path", this.form.doc_path);
      } else if (this.originalDocPath) {
        // Optional: tell backend to keep existing file
        formData.append("doc_path", this.originalDocPath);
      }

      try {
        this.isLoading = true;
        this.$store.dispatch("errors/setErrors", {});
        await axios.post(
          `/user_kyc_details/${this.$route.params.userDetailId}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        await this.saveUserTimestamp(); // Keep your audit logic
        this.isLoading = false;
        // this.$router.back();
      } catch (e) {
        console.error(e);
        this.isLoading = false;
        if (e.response && e.response.data && e.response.data.errors) {
          this.$store.dispatch("errors/setErrors", e.response.data.errors);
        }
      }
    },

    onFileChange(file) {
      if (file) {
        // Create preview for new file
        const reader = new FileReader();
        reader.onload = (e) => {
          this.previewImage = e.target.result;
        };
        reader.readAsDataURL(file);
        this.originalDocPath = null; // Clear original path when new file is selected
      } else {
        // If file is cleared, show original image if exists
        if (this.originalDocPath) {
          this.previewImage = this.mediaUrl + this.originalDocPath;
        } else {
          this.previewImage = null;
        }
      }
    },
    async saveUserTimestamp() {
      try {
        let form = {
          from_path: `/user_kyc_details/${this.form.id}`,
          from_name: "UsersKYCDetailIdPage",
          user_id: this.user.id,
          old_json: JSON.stringify(this.old_json),
          new_json: JSON.stringify(this.form),
        };
        await axios.post(`/user_timestamps`, form);
        this.$router.push('/kyc-details');
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
